






import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class Error404NotFoundView extends Vue {
    private mounted() {
        this.$root.$emit('change-active-page', 'views.errors.error404NotFoundView.pageName');
    }
}
